import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { getRepaymentCommitmentsByEntityId } from "../../../actions/loan.action";
import dispatch from "../../../middleware";

type UseRepaymentCommitmentsReturnType = {
  fetchLoanRepaymentCommitments: (entityId: string) => void;
  errorMessage: string;
};

export const useRepaymentCommitments =
  (): UseRepaymentCommitmentsReturnType => {
    const storeDispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState("");

    const fetchLoanRepaymentCommitments = useCallback(
      async (entityId: string) => {
        if (!entityId) return;
        try {
          await dispatch(
            storeDispatch,
            getRepaymentCommitmentsByEntityId(entityId)
          );
        } catch (error) {
          console.log(error);
          setErrorMessage(
            error?.message || "Unable to fetch repayment commitments"
          );
        }
      },
      [storeDispatch]
    );

    return {
      fetchLoanRepaymentCommitments,
      errorMessage,
    };
  };
